(function($){

	var isHome = $('body').hasClass('home'),
		isPage = $('body').hasClass('page'),
		isMobile = 'ontouchstart' in window,
		isSafari = /apple/i.test(navigator.vendor),

		sixMaps = $('.sixsquare-map'),
		sliders = $('.slickSlider'),
		touchhover = $('.touchhover'),		
		scrollUp = $('.scroll-up'),
		scrollDown = $('.scroll-down'),
		headSliders = $('.head-slider__container'),
		videoTries = 0,

		contentTop = 0,
		windowWidth = 0;
		
	window.sixSpinner = $('<div class="sixSpinner" style="display:none;"><svg class="sixsquare rotate-vert-center" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 58.65 58.65" height="150" width="150" ><path class="cls-1" style="fill:#4b5956;" d="M14.24,40.33V17.82a7,7,0,0,1,1.15-4.15,6.53,6.53,0,0,1,3.1-2.35,12.07,12.07,0,0,1,4.29-.74H36a12.41,12.41,0,0,1,4.24.68,6.07,6.07,0,0,1,3,2.23,6.86,6.86,0,0,1,1.1,4v5.93H30V12.67H28.26V25h8.22a9.93,9.93,0,0,1,4.2.82,6,6,0,0,1,2.76,2.48,8,8,0,0,1,1,4.09v8.5q0,4.1-2.47,5.65A12.43,12.43,0,0,1,35.3,48.1H22.5a8.72,8.72,0,0,1-6.09-2A7.5,7.5,0,0,1,14.24,40.33ZM28.35,27V46.17h1.82V27Z"/><path style="fill:none;" class="cls-2" d="M46.53,2.55H12.13a9.59,9.59,0,0,0-9.58,9.58V46.52a9.59,9.59,0,0,0,9.58,9.58H46.52a9.6,9.6,0,0,0,9.59-9.58V12.13A9.59,9.59,0,0,0,46.53,2.55Z"/><path style="fill:#91968f;" class="cls-3 outline" d="M46.53,0H12.13A12.14,12.14,0,0,0,0,12.13V46.52A12.14,12.14,0,0,0,12.13,58.65H46.52A12.14,12.14,0,0,0,58.65,46.52V12.13A12.13,12.13,0,0,0,46.53,0Zm9.58,12.13V46.52a9.59,9.59,0,0,1-9.59,9.58H12.13a9.59,9.59,0,0,1-9.58-9.58V12.13a9.59,9.59,0,0,1,9.58-9.58H46.52A9.6,9.6,0,0,1,56.11,12.13Z"/></svg></div>');
		
	var setMeasurements = function () {
	
		// Set default VH unit for mobile (Safari toolbar full height fix)
		if ( isMobile && $(window).width() != windowWidth ) {
			windowWidth = $(window).width();
			var vh = window.innerHeight * 0.01; // First we get the viewport height and we multiple it by 1% to get a value for a vh unit
			document.documentElement.style.setProperty('--vh', `${vh}px`);
		}
				
		var hh = $('.head-slider__container').first();
		if ( hh.length ) {
			contentTop = hh.outerHeight();
		} else {
			contentTop = $('header.header').outerHeight();
		}
		
	};

	// Intersection Observers
	var IO = window.IntersectionObserver || null;
	var observer = new IO(function(entries) {
		for(let i=0; i < entries.length; i++) {
			// entries[i]['intersectionRatio']
			// entries[i]['isIntersecting']
			// entries[i]['target']
			if ( entries[i]['isIntersecting'] === true ) {
				entries[i]['target'].classList.add('color');
			}
		}
	}, { threshold: [1] });
	// Example use: timelineContainer.children('.date').each(function() { observer.observe(this); } );
	
$(document).ready(function() {
	
	// Mobile
	if ( isMobile ) $('body').addClass('is-mobile');
	if ( isSafari ) $('body').addClass('is-safari');
	
	setMeasurements();
	
	// BODY ANIMATION TRIGGER
	$('body').removeClass('pre-init');
	
	// CURSOR
	if ( !isMobile ) {
		window.cursor = document.getElementById('cursor');
		
		// move cursor as mouse move
		document.addEventListener("mousemove", (e) => {
		   window.cursor.style.left = e.x + 'px'
		   window.cursor.style.top = e.y + 'px'
		});
		
		// show window.cursor on nav div
		$('.cursorNav').hover(
			function() { window.cursor.classList.add('visible'); },
			function() { window.cursor.classList.remove('visible'); }
		);
		// top
		$('.cursorNav .top').hover(
			function() { window.cursor.classList.add('top'); },
			function() { window.cursor.classList.remove('top'); }
		);
		// left
		$('.cursorNav .left').hover(
			function() { window.cursor.classList.add('left'); },
			function() { window.cursor.classList.remove('left'); }
		);
		// right
		$('.cursorNav .right').hover(
			function() { window.cursor.classList.add('right'); },
			function() { window.cursor.classList.remove('right'); }
		);
		// bottom
		$('.cursorNav .bottom').hover(
			function() { window.cursor.classList.add('bottom'); },
			function() { window.cursor.classList.remove('bottom'); }
		);
		
		// catch cursor hovering on PAGE LOAD 
		$(document).one('mousemove',function(){
			if ( $('.cursorNav:hover').length ) {
				window.cursor.classList.add('visible');
				
				if ( $('.cursorNav .top:hover').length ) { window.cursor.classList.add('top'); }
				else if ( $('.cursorNav .left:hover').length ) { window.cursor.classList.add('left'); }
				else if ( $('.cursorNav .right:hover').length ) { window.cursor.classList.add('right'); }
				else if ( $('.cursorNav .bottom:hover').length ) { window.cursor.classList.add('bottom'); }
				
			}
		});
		
	}
	
	// Project Load
	sixProjectReady( $('main.main') );
	
	// 
	if ( history.state == null && $('.head-slider__container:not(.foot) .head-slider .current').length ) {
		var current = $('.head-slider__container:not(.foot) .head-slider .current'),
			slug = current.data('slug'),
			title = document.title;
		history.replaceState( {slug: slug, title: title}, title, window.location.pathname );
	}
	
	// Content Head Slider
	if ( isPage ) {
		$('.head-slider__container.foot .head-slider .current').remove();
		$('.head-slider__container.foot .head-slider .content.head').first().addClass('current');
	}
	else if ( ! $('.head-slider__container.foot .head-slider .current').removeClass('current').next().addClass('current').length ) {
		$('.head-slider__container.foot .head-slider .content.head').first().addClass('current');
	}
	
	if ( headSliders.length ) {
		// Watch head sliders intersection
		const header_sliders_io = new IO(function(entries) {
			$.each(entries,function(ii,entry) {
			
				if ( entry.intersectionRatio > 0.5 ) {
					entry.target.classList.add('visible');
					if ( $(entry.target).find('.current').hasClass('canplay') ) {
						$(entry.target).find('.current').find('video')[0].play();
					}
				}
				else {
					entry.target.classList.remove('visible');
					if ( $(entry.target).find('.current').hasClass('canplay') ) {
						$(entry.target).find('.current').find('video')[0].pause();
					}
					
					if ( entry.intersectionRatio > 0.0 ) {
						if ( !entry.target.classList.contains('foot') && !window.autoScrolling ) {
							var curSlide = $(entry.target).find('.head-slider .current'),
								slug = curSlide.data('slug');
								
							if ( slug.length && $('.content-section__container > .content').data('slug') != slug ) {
								console.log('Scroll Load call ' + slug);
								sixProjectLoad(slug, curSlide.data('title'));
								
							}
						}
					}
				}

			});
		}, { threshold: [0.0,0.4,0.5,0.6,1] });

		headSliders.each(function() {
			header_sliders_io.observe(this);
		});
		
		setTimeout(function() {
			// video head slider current slide
			var vhs = headSliders.filter('.visible');
			if ( vhs.length && vhs.find('.current').hasClass('video') ) sixProjectSlideVideo( vhs.find('.current') );
		}, 100);
		
	}
	
	// Slick Slider
//	sliders.each(function(){});
	
	// Easy Grid Slider
	var gS = $('.gridSlider').data('gridSliderPos',0); 
	$('<button class="gS_prev"></button><button class="gS_next"></button>').appendTo(gS).click(function(){
		var t = $(this);
		var gS = t.parent('.gridSlider');
		var cur = gS.data('gridSliderPos');
		var move = ( t.hasClass('gS_prev') ? -1 : 1 );
		var slides = gS.children('.cell');
		var maxed = ( ( gS.width() - 1 ) > ( slides.last().position().left ) );
		if ( ( ! maxed || move < 0 ) && (cur + move) >= 0 ) {
			gS.removeClass('gs-' + cur);
			gS.addClass('gs-' + (cur + move) ).data('gridSliderPos', cur + move);
		}
	});
		
	// Scroll Down widget
	if ( scrollDown.length && contentTop ) {
		scrollDown.click(function(){
			var t = (contentTop/400) * 800;
			$('html, body').animate({ scrollTop: contentTop }, t, 'easeInQuad');
		});
	}
	
	// Logo page
	if ( isMobile ) $('section.logos .logo').each(function(){ observer.observe(this); });
	
	// Resize with throttle
	$(window).on('resize', Foundation.util.throttle( function (event) {

		sliders.each(function() {
			var t = $(this),
				h = t.css('height','').height();
				if ( ! t.hasClass('hero') ) t.height(h);
	
		});
	
		setMeasurements();
					
	}, 300) ).resize();

	// Scrolling with throttle
	$(window).on('scroll', Foundation.util.throttle( function (event) {
	
		var wTop = $(this).scrollTop();
			
		sixSquareMapCheck();
		
		if ( contentTop ) {
		if ( wTop >= contentTop - 20 ) {
			$('header.header').addClass('scrolled');
		} else {
			$('header.header').removeClass('scrolled');
		}
		}
				
		if ( scrollDown.length ) {
			if ( scrollDown.offset().top > contentTop ) {
				scrollDown.addClass('collapse');
			} else {
				scrollDown.removeClass('collapse');
			}
		}

			
	}, 300) ).scroll();
	
	// Scrolling 
	$(window).on('scroll', function (event) {
	
	} ).scroll();
	
	function sixSquareMapCheck() {
		// Google Maps
		if ( sixMaps.length ) {
			sixMaps.each(function(i, el) {
				el = $(el);
				if ( el.visible('middle') ) { 
					sixSquareMapFeatures( el );
					sixMaps = sixMaps.not(this);
				}
			});
		}
	}
	
	// SVG load
	$('img.svg-load').each( function() { 
		var $img = $(this);
		var imgID = $img.attr('id');
		var imgClass = $img.attr('class');
		var imgURL = $img.attr('src');
		$.get({
			url: imgURL,
			cache: true,
			dataType: 'xml',
			success: function (data) {
				// Get the SVG tag, ignore the rest
				var $svg = $(data).find('svg');
				// Add replaced image's ID to the new SVG
				if(typeof imgID !== 'undefined') {
				    $svg = $svg.attr('id', imgID);
				}
				// Add replaced image's classes to the new SVG
				if(typeof imgClass !== 'undefined') {
				    $svg = $svg.attr('class', imgClass);
				}
				// Remove any invalid XML tags as per http://validator.w3.org
				$svg = $svg.removeAttr('xmlns:a');
				// Replace image with new SVG
				$img.replaceWith($svg);
			}
		});
	});

		
	// Off Canvas links: close on click. This ensures the menu is hidden when navigating back. Reducing the transition was somehow necessary. It is fixed by onClick code in nav-offcanvas-topbar.php. The callback below doesn't get called.
	$('#off-canvas a').click(function(e){
		if ( $(this).parent().hasClass('is-accordion-submenu-parent') ) return true;
		if ( $(this).attr('target') == "_blank" ) return true;
		if ( $(this).parent().hasClass('noclick') ) return false;
		
		var t = $(this);
				
		// don't follow link	
		e.preventDefault();
		
		// Close off-canvas
		$('#off-canvas').foundation('close');
		
		// Trigger body pageLoader
//		$('body').addClass('loading');
		
		// follow link after off-canvas closes
		$('#off-canvas').on('closed.zf.offCanvas', function () {
			window.location = t.attr('href');
		});		

		return false;

	});
		
	// Off-Canvas inner: stop propagation of transitionend event causing premature transition on close
	$('.offcanvas-full-screen-inner').on('transitionend',(e)=>e.stopPropagation());

	// Off-Canvas Open [verified]
	$('#off-canvas').on('opened.zf.offCanvas', function (e) {

	//	document.activeElement.blur();
		

	});
	
	// Off-Canvas Open Ended [verified]
	$('#off-canvas').on('openedEnd.zf.offCanvas', function (e) {
		
		sixSquareMapCheck();
		document.activeElement.blur();
		
	});

	// Off-Canvas Close [verified]
	$('#off-canvas').on('close.zf.offCanvas', function (e) {

	});
	
	// Off-Canvas Closed [verified]
	$('#off-canvas').on('closed.zf.offCanvas', function (e) {

	});

});

$(window).on('load', function() {

});

// Breakpoint Change
$(window).on('changed.zf.mediaquery ready', function(event, newSize, oldSize) {
	if ( typeof newSize == 'undefined' ) var newSize = Foundation.MediaQuery.current;

	if ( newSize == 'small' ) {
		
	} else if ( oldSize == 'small' ) {

	} 
	if ( newSize && oldSize ) { // actual change, not first call (ready)
		
		// Easy Grid Slider reset
		$('.gridSlider').each( function() {
			var gS = $(this);
			var cur = gS.data('gridSliderPos');
			gS.removeClass('gs-' + cur).data('gridSliderPos',0);
		});
		
	}
});

// Gravity Forms: FORM POST RENDER (This includes initial form load, going to the next/previous page on multi-page forms, form rendered with validation errors, confirmation message displayed, etc.)
$(document).bind('gform_post_render', function(event,formID){
	
	
});

// fn: Slick Initialize
function sixSquareSlickInitialize(slider) {
	var t = $(slider),
		initialSlide = Math.max(0,t.children('.slide.initialSlide').index());
	
	t.on('init',function(e,slick){
		var t = $(this),
			h = t.height();
			
		if ( slick.options.centerMode ) t.addClass('centerMode');
	//	if ( ! t.hasClass('hero') ) t.height(h);
	
	}).on('reInit',function(e,slick) {
		var t = $(this),
			h = t.css('height','').height();
			
	//		if ( ! t.hasClass('hero') ) t.height(h);
			
	}).on('beforeChange', (event, slick, currentSlide, nextSlide) => {
//			var nextSlide = slick.$slides[nextSlide];

		
	}).on('afterChange', function(event, slick, currentSlide) {
//			var slide = $(event.target).find('.slick-current');
		
	}).slick({
		// Default options
/*			infinite: false,
		arrows: false,
		swipeToSlide: true,
		slidesToShow: 3,
		variableWidth: true,
		*/
		initialSlide: initialSlide,
		centerPadding: '20%',
		autoplay: false,
		autoplaySpeed: 5000,
		speed: 600,
		responsive: [
			{ 	breakpoint: 1680,
				settings: {
					centerPadding: '15%'
				}
			}
		]
	});
}

// fn: Project prep
// called on page load and ajax project load
function sixProjectReady ( content ) {

	// Section Layout Cursor Navigation
	content.find('.cursorNav').click( sixProjectCursorNav );
	
	// Inline projects grid
	content.find('.ssproject-grid-inline .ssproject-thumb').click( function(e) {
		
		var source = $(e.currentTarget),
			slug = source.data('slug'),
			title = source.data('title');
		
		e.preventDefault();
		
		sixProjectLoad( slug, title );
		
		console.log( e );
		
		return false;
	});
	
	// Slick Slider
	content.find('.slickSlider').each(function(){ sixSquareSlickInitialize(this); });
	
	/*on('init',function(e,slick){
		if ( slick.options.centerMode ) $(this).addClass('centerMode');
	}).slick({
		// Default options
		centerPadding: '20%',
		responsive: [
			{ 	breakpoint: 1680,
				settings: {
					centerPadding: '15%'
				}
			}
		]
	});*/
	
	return content;
	
}

// fn: Project Nav
function sixProjectCursorNav (e) { 
	var direction = e.target.className,
		source = $(this.parentNode),
		target = null,
		action = null;
		
	switch (direction) {
		
		case 'top':
			target = source.prev();
			action = 'scroll';
			break;
			
		case 'left':
			target = source.find('.current').prev('.content:not(.page)');
			if ( !target.length ) target = source.find('.content').last();
			action = 'current';
			break;
			
		case 'right':
			target = source.find('.current').next('.content');
			if ( !target.length ) target = source.find('.content:not(.page)').first();
			action = 'current';
			break;
			
		case 'cursorNav': /* middle click */
			direction = 'bottom';
					
		case 'bottom':
// not working
			if ( source.hasClass('foot') ) target = source.prev();
			else target = source.next();
			action = 'scroll';
			
			break;
		
	}
	
	if ( source && target ) {
//console.log ('t0 %%%%%%%% ');console.log(target);		
		if ( action == 'scroll' ) {
		
			if ( direction == 'bottom' && source.hasClass('head-slider__container') && target.data('slug') != source.find('.current').data('slug') ) {
				//
				// Project change!
				//
				
				var container = source.closest('.content-section__container'),
					slug = source.find('.current').data('slug'),
					title = source.find('.current').data('title');
				
				sixProjectLoad( slug, title );
/*				
				// Clear previous project
				container.children('.content').remove();

				// Add spinner
				container.children('.head-slider__container').first().after( target = sixSpinner.clone().fadeIn(1200).css('display','') );
	
				$.ajax({
					
					url: window.sixScript.ajaxurl,
					type: 'POST',
					data: {
						'_ajax_nonce' : window.sixScript.ajaxnonce,
						'action' : 'ssProject_content',
						'project' : slug
					},
					success: function (data) {
						
						if ( data.length ) {
						
							target.fadeOut(700,function() {
								sixProjectReady( $(data).replaceAll(this) );
							});
							
							$('.head-slider__container.foot').show();
							
						} else {
							
						}
		
					}
					
				});
*/				
			} else {
				$('html,body').animate({
					scrollTop: target.offset().top
				}, 1000, 'easeOutCubic');
			}
			
		} else if ( action == 'current' ) {
			// only in use by the project top/bottom sliders? weird phrasing
			
			sixProjectSliderAdvance ( target.data('slug'), (source.hasClass('foot')? 'foot' : '') );

		}
		
	}
}

// fn: Project Slider Advance
function sixProjectSliderAdvance ( newCurrentSlug, slider ) { 
	var newCurrentSlug = (newCurrentSlug?newCurrentSlug:''),
		slider = (slider?slider:''),
		topSlider = $('.head-slider__container:not(.foot)'),
		footSlider = $('.head-slider__container.foot'),
		inlineGrid = $('.ssproject-grid-inline'),
		current = topSlider.find('.current'),
		target = topSlider.find('.' + newCurrentSlug);


		
	if ( !newCurrentSlug || !target.length ) return false;
	
console.log('Slider Advance to ' + newCurrentSlug);
	
	if ( slider != 'foot' ) {
		// top slider
		if ( current.length > 1 || current.data('slug') != newCurrentSlug ) {
			if ( current.hasClass('video') ) current.find('video')[0].pause();
			current.removeClass('current');
			target.addClass('current');
		}
		// video
		if ( topSlider.hasClass('visible') ) sixProjectSlideVideo( target );
	}
	
	// foot slider
	current = footSlider.find('.current'),
	target = footSlider.find('.' + newCurrentSlug),
	target = ( slider == 'foot' ? target : target.next('.content') ),
	target = ( target.length ? target : footSlider.find('.content:not(.page)').first() );
	if ( current.length > 1 || current.data('slug') != target.data('slug') ) {
		if ( current.hasClass('video') ) current.find('video')[0].pause();
		current.removeClass('current');
		target.addClass('current');
	}
	// video
	if ( footSlider.hasClass('visible') ) sixProjectSlideVideo( target );
	
	
	// inline Grid
	current = inlineGrid.find('.current'),
	target = inlineGrid.find('.' + newCurrentSlug);
	if ( current.length > 1 || current.data('slug') != newCurrentSlug ) {
		current.removeClass('current');
		target.addClass('current');
	}
}

function sixProjectSlideVideo( slide ) {

	if ( slide.hasClass('video') ) { //console.log('SLIDE HAS VIDEO TRY PLAYING');
		video = slide.find('video'); 
	
		if ( video.length ) { //console.log('SLIDE HAS VIDEO TRY PLAYING2');
		
			if ( null == video.attr('src') ) {
				// lazy load video
				videoTries = 0;
				video.attr('src', video.data('src'));
				video[0].load();
			}
			
			video = video[0];
	
			var promise = video.play();
	
			if (promise !== undefined) {
				promise.catch(error => {
					// Auto-play was prevented
					// Show a UI element to let the user manually start playback
										console.log('SLIDE HAS VIDEO FAIL ' + megaVideoTries);
					if ( videoTries < 3 ) {
						videoTries++;
						setTimeout(function(){
							sixProjectSlideVideo( slide );
						},400);
					}
				}).then(() => {
					// Auto-play started
											// console.log('SLIDE HAS VIDEO PLAYING');
					slide.addClass('canplay');
					//if ( megaPauseState ) video.pause();
				});
			}

		
			return true;
		}
	}

	
}

// fn: Project Load
function sixProjectLoad ( slug, title ) { 
	//
	// Project change!
	//
	
	var container = $('.content-section__container'),
		slug = (slug?slug:false),
		title = (title?title:''),
		target = false;
	
	if ( !slug ) return;
	
console.log('Project Load ' + slug);
	
	// Clear previous project
	container.children('.content').remove();

	// Add spinner
	console.log( 'Spin add ' + Date() );
	container.children('.head-slider__container').first().after( target = sixSpinner.clone() ); //.fadeIn(1200).css('display','')
		console.log( 'Spin in ' + Date() );
	target.fadeIn(1200);
	
	// Load Project
	$.ajax({
		
		url: window.sixScript.ajaxurl,
		type: 'POST',
		data: {
			'_ajax_nonce' : window.sixScript.ajaxnonce,
			'action' : 'ssProject_content',
			'project' : slug
		},
		success: function (data) {
						
			if ( data.length ) {
				
				// Fade out spinner, insert content
				target.fadeOut(700,function() {
					sixProjectReady( $(data).replaceAll(this) );
									
					// Advance sliders/grids as needed
					sixProjectSliderAdvance( slug, '' );
				
					// show foot slider (home page is hidden by default)
					$('.head-slider__container.foot').show();
					
					// Push history state!
					history.pushState( {slug: slug, title: title}, title, '/work/' + slug );
					document.title = title;
					
					window.autoScrolling = false; 
				});				
			
			} else {
				// No data! Reload the page??!
				window.location.reload();	
			}

		},
			
	});
	
	// scroll page to spinner
	window.autoScrolling = true;
	$('html,body').animate({
	
		scrollTop: target.offset().top
	
	}, 1000, 'easeOutCubic', function() { console.log( 'Spin Scrolled ' + Date() ); } );

}
x=3;

// fn: Visible
$.fn.visible = function(type) {
	var t            = $(this);
	if ( typeof t.offset() != "object" ) { console.log('visible: not object.'); console.log(this); return false; }
	var	$w            = $(window),
		viewTop       = $w.scrollTop(),
		viewBottom    = viewTop + $w.height(),
		_height		  = t.height(),
		offset        = t.offset(),
		_top          = offset.top,
		_middle		  = _top + (_height/2),
		_bottom       = _top + _height,
		_10			  = _height*0.1;
		
		if ( offset.left <= (0 - t.width()) || offset.left > $w.width() ) return false;
		
		switch (type) {
			case 'top': return (_top +_10 >= viewTop) && (_top < viewBottom);
			case 'middle': return (_middle >= viewTop) && (viewBottom >= _middle);
			//case 'full':
			default: return (_bottom <= viewBottom) && (_top >= viewTop);
		}
};

// Google Maps Callback fn
window.sixSquareMapInit = function () {
	// Create a new StyledMapType object, passing it an array of styles,
	// and the name to be displayed on the map type control.
	var styledMapType = new google.maps.StyledMapType([
	  {
		"elementType": "geometry",
		"stylers": [{
			"color": "#f5f5f5"
		  }]
	  },
	  {
		"elementType": "labels.icon",
		"stylers": [{
			"visibility": "off"
		  }]
	  },
	  {
		"elementType": "labels.text.fill",
		"stylers": [{
			"color": "#616161"
		  }]
	  },
	  {
		"elementType": "labels.text.stroke",
		"stylers": [{
			"color": "#f5f5f5"
		  }]
	  },
	  {
		"featureType": "administrative.land_parcel",
		"elementType": "labels.text.fill",
		"stylers": [{
			"color": "#bdbdbd"
		  }]
	  },
	  {
		"featureType": "poi",
		"elementType": "geometry",
		"stylers": [{
			"color": "#eeeeee"
		  }]
	  },
	  {
		"featureType": "poi",
		"elementType": "labels.text",
		"stylers": [{
			"visibility": "off"
		  }]
	  },
	  {
		"featureType": "poi",
		"elementType": "labels.text.fill",
		"stylers": [{
			"color": "#757575"
		  }]
	  },
	  {
		"featureType": "poi.business",
		"stylers": [{
			"visibility": "off"
		  }]
	  },
	  {
		"featureType": "poi.business",
		"elementType": "labels.text",
		"stylers": [{
			"visibility": "off"
		  }]
	  },
	  {
		"featureType": "poi.park",
		"elementType": "geometry",
		"stylers": [{
			"color": "#e5e5e5"
		  }]
	  },
	  {
		"featureType": "poi.park",
		"elementType": "labels.text.fill",
		"stylers": [{
			"color": "#9e9e9e"
		  }]
	  },
	  {
		"featureType": "road",
		"elementType": "geometry",
		"stylers": [{
			"color": "#ffffff"
		  }]
	  },
	  {
		"featureType": "road",
		"elementType": "labels.icon",
		"stylers": [{
			"visibility": "off"
		  }]
	  },
	  {
		"featureType": "road.arterial",
		"elementType": "labels.text.fill",
		"stylers": [{
			"color": "#757575"
		  }]
	  },
	  {
		"featureType": "road.highway",
		"elementType": "geometry",
		"stylers": [{
			"color": "#dadada"
		  }]
	  },
	  {
		"featureType": "road.highway",
		"elementType": "labels.text.fill",
		"stylers": [{
			"color": "#616161"
		  }]
	  },
	  {
		"featureType": "road.local",
		"elementType": "labels.text.fill",
		"stylers": [{
			"color": "#9e9e9e"
		  }]
	  },
	  {
		"featureType": "transit",
		"stylers": [{
			"visibility": "off"
		  }]
	  },
	  {
		"featureType": "transit.line",
		"elementType": "geometry",
		"stylers": [{
			"color": "#e5e5e5"
		  }]
	  },
	  {
		"featureType": "transit.station",
		"elementType": "geometry",
		"stylers": [{
			"color": "#eeeeee"
		  }]
	  },
	  {
		"featureType": "water",
		"elementType": "geometry",
		"stylers": [{
			"color": "#80bac5"
		  }]
	  },
	  {
		"featureType": "water",
		"elementType": "labels.text.fill",
		"stylers": [{
			"color": "#9e9e9e"
		  }]
	  }
	], {name: 'Styled Map'});
	
	sixMaps.each(function() {
	
		var googleMap = new google.maps.Map( this, {
			zoom: 15,
			center: new google.maps.LatLng( sixScript.gmap_lat, sixScript.gmap_long ),
			mapTypeId: 'roadmap',
			mapTypeControl: false,
			fullscreenControl: false,
			streetViewControl: false,
			scrollwheel: false,
			"featureType": "poi.business",
			"stylers": [
				{
					"visibility": "off"
				}
			]		
		});

		//Associate the styled map with the MapTypeId and set it to display.
		googleMap.mapTypes.set('styled_map', styledMapType);
		googleMap.setMapTypeId('styled_map');
		
		$(this).data('gmap', googleMap);
	
	});

}

// Google Maps Feature / pin / display fn
function sixSquareMapFeatures( map ) {

	if ( typeof map != 'object' ) return false;
	
	var googleMap = map.data('gmap');

	if ( typeof map.data('gmapMarkers') == 'undefined' ) {
		// First init!
		var features = [
			{
				position: new google.maps.LatLng( sixScript.gmap_lat, sixScript.gmap_long ),
				type: 'info',
				title: sixScript.blogname ,
				animation: google.maps.Animation.DROP
			}
		];
		var xicon = {
			url: sixScript.gmap_icon,
			scaledSize: new google.maps.Size(39,39),
			origin: new google.maps.Point(0,0),
			anchor: new google.maps.Point(19,19)
		};
		var icon = {
			path: "m4.915 31.001v-22.51c-.062-1.47.341-2.922 1.15-4.15.771-1.08 1.852-1.9 3.1-2.35 1.374-.505 2.827-.756 4.29-.74h13.22c1.443-.022 2.877.208 4.24.68 1.21.409 2.26 1.189 3 2.23.771 1.187 1.155 2.585 1.1 4v5.93h-14.34v-10.75h-1.74v12.33h8.22c1.443-.036 2.877.244 4.2.82 1.159.514 2.126 1.382 2.76 2.48.693 1.249 1.038 2.661 1 4.09v8.5c0 2.733-.823 4.616-2.47 5.65-2.033 1.134-4.344 1.675-6.67 1.56h-12.8c-2.21.13-4.387-.585-6.09-2-1.516-1.524-2.307-3.625-2.17-5.77zm14.11-13.33v19.17h1.82v-19.17z",
			fillColor: "#4b5956",
			fillOpacity: 1,
			strokeWeight: 0,
			rotation: 0,
			scale: 1, // Default scale is 22x22
			anchor: new google.maps.Point(11,11),
			
		};
		// Create markers.
		map.data('gmapMarkers',[]);

		features.forEach(function(feature) {
		  var marker = new google.maps.Marker({
			position: feature.position,
			map: googleMap,
			icon: icon,
			animation: feature.animation,
			title: feature.title,
			clickable: true
		  }).addListener('click', function(e) {
					var pid = sixScript.gmap_placeid,
						destination = ( pid && pid.length? pid : sixScript.gmap_lat + ',' + sixScript.gmap_long),// sixScript.blogname ),
						url = "https://www.google.com/maps/dir/?api=1&destination=" + destination + "&destination_place_id=" + pid;
						window.open(url);
			});
		  map.data('gmapMarkers').push(marker);
		});

	} else {

		// reinit
		googleMap.setCenter( new google.maps.LatLng( sixScript.gmap_lat, sixScript.gmap_long ) );
		map.data('gmapMarkers')[0].setAnimation( google.maps.Animation.DROP );
		
	}
	
}

// jQuery Easings
$.extend( $.easing, {
	easeOutCubic: function (x, t, b, c, d) {
			return c*((t=t/d-1)*t*t + 1) + b;
		},
	easeInQuad: function (x, t, b, c, d) {
	    return c*(t/=d)*t + b;
	},
});


})(jQuery);